/**
 * PromotionDialog exports
 */

import PromotionDialog from './PromotionDialog';
export type { PromotionDialogProps } from './PromotionDialog';
export default PromotionDialog; 